export default {
    id: null,
    year: new Date().getFullYear(),
    team_member: 0,
    monthly_expenses: 0,
    broker_percent: 0,
    broker_yearly_max: true,
    broker_dollar_max: 0,
    franchise_fee: false,
    annual_franchise_fee: 0,
    listings_sold: 0,
    buyers_sold: 0,
    listings_commission_percent: 0,
    buyers_commission_percent: 0,
    isa: false,
    isa_percent_total: 0,
    isa_percent: 0,
    referral_fee_count: 0,
    referral_fee_percent: 0,
    transaction_fee: false,
    transaction_fee_amount: 0,
    buyer_transaction_fee: false,
    buyer_transaction_fee_amount: 0,
    additional_cos: 0
};